import type { RouteResources } from '@atlassian/react-resource-router';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';
import { legacyReportsCreatedVsResolvedRoute } from '@jira/router-routes__legacy-reports-created-vs-resolved-routes/src/legacyReportsCreatedVsResolvedRoute.tsx';
import { getReportsCommonResource } from './getReportsCommonResource.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const legacyReportsCreatedVsResolvedRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(legacyReportsCreatedVsResolvedRoute, () => ({
		layout: genericProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getBusinessProjectResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...getReportsCommonResource(),
			getConsolidationStateResource(),
		],

		entryPoint: () => pageEntryPoint,
	}));
